import { createSortByDate } from "../../utils/createSortByDate.js";
import type { Application } from "../Application.js";
import type { CompetitionCategoryType } from "../CompetitionCategoryType.js";

const sortByDate = createSortByDate("createdAt", "asc");

export function createSortApplication(
	competition: CompetitionCategoryType | null,
): (first: Application, second: Application) => number {
	return function (first: Application, second: Application): number {
		const firstHasTopped =
			first.categories.find((category) => category.type === competition && category.topped) !== undefined;
		const secondHasTopped =
			second.categories.find((category) => category.type === competition && category.topped) !== undefined;

		if (firstHasTopped === secondHasTopped) {
			return sortByDate(first, second);
		}
		if (firstHasTopped) {
			return -1;
		}
		if (secondHasTopped) {
			return 1;
		}

		return sortByDate(first, second);
	};
}
